import TableCard from "./TableCard";
import { EditIcon } from "../kits/Icons";
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";

import img from "../../assets/images/cpu.png";
export default function Test() {
  const returnJSX = (productId) => {
    return (
      <div className="d-flex justify-content-center">
        <NavLink to={`/product/${productId}`}>
          <div onClick={() => {}}>
            <EditIcon color="white"></EditIcon>
          </div>
        </NavLink>
      </div>
    );
  };
  const [content, setContent] = useState([
    {
      type: "title",
      img: (
        <div>
          <img
            style={{
              width: "50px",
              height: "50px",
              marginRight: "auto",
              marginLeft: "auto",
              borderRadius: "50%",
            }}
            src={img}
          ></img>
        </div>
      ),
      title: "cdsd",
      price: "1200",
      description: "ooo",
      discount: "100",
      rate: "2",

      name: "title",
      content: "mmm",
    },
    {
      img: (
        <div>
          <img
            style={{
              width: "50px",
              height: "50px",
              marginRight: "auto",
              marginLeft: "auto",
              borderRadius: "50%",
            }}
            src={img}
          ></img>
        </div>
      ),
      type: "title",
      title: "cdsd",
      price: "1200",
      description: "sas",
      discount: "100",
      rate: "2",

      name: "title",
      content: "mmm",
    },
  ]);

  const [header, setHeader] = useState([
    {
      type: "img",
      title: "عکس",
      name: "img",
    },
    {
      type: "title",
      title: "عنوان",
      name: "title",
    },
    {
      type: "title",
      title: " قیمت  ",
      name: "price",
    },
    {
      type: "description",
      title: " توضیحات ",
      name: "description",
    },
    {
      type: "title",
      title: " مبلغ تخفیف  ",
      name: "discount",
    },
    {
      type: "title",
      title: " امتیاز  ",
      name: "rate",
    },

    {
      type: "operation",
      title: " عملیات ",
      name: "operation",
    },
  ]);
  return (
    <div>
      {content.map((val, ind) => {
        return (
          <TableCard
            column={header}
            content={{
              ...val,
              operation: returnJSX(val.id),
            }}
            bg={"primary_custom"}
            widthParent={"80%"}
            showSelect="true"
          ></TableCard>
        );
      })}
    </div>
  );
}
